<template>
  <div class="zkindex">
	  <!-- <div class="tankuang" v-show="tanbol" @click="tanck()">
      <img src="../assets/tan.jpg" alt="">
	  </div> -->
    <div class="index">
      <div class="swiper-news-login">
        <swiper :options="swiperOption" ref="mySwiper" class="myswiper" v-if="swiperdata.length>0">
          <!-- slides -->
          <swiper-slide v-for="(item,index) in swiperdata" :key="index" class="slider">
            <!-- <img :src="item.img_url" /> -->
            <img src="../assets/lantu.jpg" @click="news_sure()" alt="">
            <!-- <div class="slide-title">{{item.title}}</div> -->
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="news-laws">
          <div class="news-title-box">
            <div>
              <div>
                <h3 style="color:#fff">登录</h3>
                <!-- <p>LOGIN</p> -->
                <p style="color: #fff;margin-top: 10px;"><span style="font-size: 16px;">账号：</span>
                  <input type="text" placeholder="请输入身份证号" maxlength="18" v-model="idcard"></p>
                <p style="color: #fff;"><span style="font-size: 16px;">密码：</span><input type="password" placeholder="请输入密码"
                    v-model="UserPsd"></p>
                <div><span @click="index_m()" style="color:#fff">找回密码</span>
                  <!--<span @click="index_z()">注册账号</span> -->
                </div>
                <button @click="Login()" class="button">立即登录</button>
                <a style="margin-top:12px" href="http://yxpx_admin.jxjyedu.club/index.php?controller=login&action=login"
                  target="_blank"><button>管理员登录</button></a>
              </div>
            </div>
          </div>
          <indexlaws :msg="lawsjson" v-show="newslawsState==1"></indexlaws>
        </div>

        <!-- <div class="login-box" v-show="type">
          <div class="login-title-box">
              <div class="login-title"></div>
          </div>
            <div class="info-box">
                <input type="text" placeholder="请输入身份证号" maxlength="18" class="register_content_input" v-model= "idcard"><br>
                <input type="password" placeholder="请输入密码" class="register_content_input input-pw" v-model="UserPsd"><br>
                <input type="text" placeholder="请输入验证码" maxlength="4" class="yanzhengma_input" @blur="checkLpicma" v-model="picLyanzhengma">
                <input type="button" id="code" @click="createCode"  class="verification1" v-model="checkCode"/> <br>
                <a class="user_login" @click="Login">登录</a>
                <div class="btns-box">
                    <router-link to="/findpw" class="find-pw">找回密码</router-link>
                    <router-link to="/register" class="btn-regin">注册账号</router-link>
                </div>
            </div>
      </div>
      <div class="login-index-success" v-show="!type">
          <img class="user-image" src="/static/images/personal/man.png" v-show="sex==1" />
          <img class="user-image" src="/static/images/personal/women.png" v-show="sex==0"/>
          <div class="user-name">{{name}}</div>
          <div class="title"> </div>
          <div class="btn-personal"><router-link to="/my">个人中心</router-link></div>
          <div class="btn-login"><span @click="logout">退出登陆</span></div>
        </div>-->
      </div>
      <div class="box wrap clearfix">
        <div>
          <div><span>政策法规</span><span @click="index_l()">更多>></span></div>
          <router-link :to="'/newsDetails/' + a.id" v-for="(a,index) in lawsjson.list" :key="index" class="index_li">
            <span></span><span>{{a.title}}</span><span>[{{a.time.split(" ")[0]}}]</span>
          </router-link>
        </div>
        <div class="float_l">
          <div><span>工作动态</span><span @click="index_w()">更多>></span></div>
          <router-link :to="'/newsDetails/' + d.id" v-for="(d,index) in worksjson.list" :key="index" class="index_li">
            <span></span><span>{{d.title}}</span><span>[{{d.time.split(" ")[0]}}]</span>
          </router-link>

        </div>
        <!-- <div class="left fl">
          <h3>
            <span class="spn">专业课学习平台</span>
            <img src="/static/images/index/xiangyun.png" />
          </h3>
          <div class="list">
            <ul>
              <li v-for="item in kecheng_type" :key="item.id" @click="tocourse(item.id)">
                <span>
                  <img :src="item.img_url" />
                </span>
                <span>{{item.name}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="right fr">
          <div class="top">
            <a href="https://www.hnzjgl.gov.cn/">
              <img src="/static/images/index/logo-2.png" alt />
            </a>
          </div>
          <div class="bottom">
            <router-link to="/gongxuke">
              <img src="/static//images/index/hnzj-logo.jpg" alt />
            </router-link>
          </div>
        </div> -->
      </div>
      <div class="index_sear">
        <div class="search">
          <input type="text" placeholder="岗位培训平台档案查询" style="cu" readonly="readonly"><img src="../assets/cxss.png" alt=""
            @click="index_i()">
        </div>
        <div class="index_work">
          <div><span>新闻资讯</span><span @click="index_g()">更多>></span></div>
          <router-link :to="'/newsDetails/' + b.id" v-for="(b,index) in newsjson.list" :key="index" class="index_w ">
            <span></span><span>{{b.title}}</span><span>[{{b.time.split(" ")[0]}}]</span>
          </router-link>
        </div>
      </div>
      <div class="index_ban">
        <div>
          <p><span>在线培训流程</span></p>
          <router-link to=""><img src="../assets/ban_1.png" alt="" class=".img"></router-link>
          <img src="../assets/next.png" alt="">
          <router-link to="/courses"><img src="../assets/ban_2.png" alt="" class=".img"></router-link>
          <img src="../assets/next.png" alt="">
          <router-link to="/courses"><img src="../assets/ban_3.png" alt="" class=".img"></router-link>
          <img src="../assets/next.png" alt="">
          <router-link to><img src="../assets/ban_5.png" alt="" class=".img"></router-link>
          <img src="../assets/next.png" alt="">
          <router-link to="/"><img src="../assets/ban_4.png" alt="" class=".img"></router-link>
        </div>
        <div>
          <p><span>帮助中心</span><span @click="index_x()">更多>></span></p>
          <router-link :to="'/newsDetails/' + helps.id" v-for="(helps,index) in helpsjson.list" :key="index" class="index_h">
            <span></span><span>{{helps.title}}</span>
            <!-- <span>[{{helps.time.split(" ")[0]}}]</span> -->
          </router-link>
        </div>
      </div>
      <div class="index_cour">
        <p><span>培训课程</span><span @click="index_c()">更多>></span></p>
        <div>
          <courses></courses>
        </div>
      </div>
      <!-- <div class="index_y">
        <p><span>河南省专业技术人员继续教育专业科目学习平台</span></p>
        <div class="index_d">
          <a href="http://www.jxjyedu.org.cn/" target="_blank" class="a_img">
            <div>河南省继续教育学会</div>
            <div>(教育类)</div>
          </a>
        </div>
      </div>
      <div class="index_y">
        <p><span>河南省专业技术人员继续教育公需科目学习平台</span></p>
        <div class="index_for">
            <a href="http://hnzj.ghlearning.com/" target="_blank" class="a_img">
              <div>
                河南专技在线
              </div>
            </a>
            <a href="http://hnzj.haust.edu.cn/" target="_blank" class="a_img">
              <div>
                大豫专技网
              </div>
            </a>
            <a href="http://hnzj.chinahrt.com/" target="_blank" class="a_img">
              <div>
                河南省专业技术人员
              </div>
              <div>
                继续教育网
              </div>
            </a>
            <a href="http://haacee.org.cn/" target="_blank" class="a_img">
              <div>
                河南省专业技术人员
              </div>
              <div>
                继续教育网络学院
              </div>
            </a>
        </div>
      </div>
      <div to class="procedure-box">
        <router-link to="/register" class="xyzc"></router-link>
        <router-link to="/courses" class="xkjf"></router-link>
        <router-link to="/courses" class="zxxx"></router-link>
        <router-link to class="zxks"></router-link>
        <router-link to="/checkzhengshu" class="zscx"></router-link>
      </div> -->
      <!-- <div class="index-news">
        <indexworks :msg="worksjson"></indexworks>
        <indexhelps :msg="helpsjson"></indexhelps>
      </div> -->
      <!-- <div class="continue-education">
        <div class="continue-edu-title"></div>
          <div class="year-choose">
              <div class="year-title">培训年度:</div>
              <ul class="year">
                  <li :class="{on:yeartabState==''}" @click="courseYear()">全部</li>
                  <li :class="{on:yeartabState==item}" v-for="(item,index) in kecheng_year" :key="index" @click="courseYear(item)">{{item}}</li>
              </ul>
          </div>
          <div class="course-choose">
              <div class="course-title">课程类型:</div>
              <ul class="course">
                  <li :class="{on:typetabState==''}" @click="courseType()">全部</li>
                  <li :class="{on:typetabState==item.id}" v-for="(item,index) in kecheng_type" :key="index" @click="courseType(item.id)">{{item.name}}</li>
              </ul>
          </div>
          <div class="kinds-choose">
              <div class="kinds-title">课程分类:</div>
              <ul class="kinds">
                  <li :class="{on:categorytabState==''}" @click="courseCategory()">全部</li>
                  <li :class="{on:categorytabState==item.id}" v-for="(item,index) in kecheng_category" :key="index" @click="courseCategory(item.id)">{{item.name}}</li>
              </ul>
          </div>
    </div>
    <div class="course-box">
        <router-link :to="'/courseDetails/' + item.id" v-for="item in courseslist" :key="item.id" class="course-item" >
            <div class="item-img"><img :src="item.img_url"></div>
            <p class="item-name">{{item.title}}</p>
            <div class="item-other">
                <div class="item-time">{{item.kecheng_jie_num}}学时</div>
                <div class="item-teacher">主讲：<span class="teacher-name">{{item.jiangshi.name}}</span></div>
            </div>
        </router-link>
      </div>-->
      <!-- <div class="friend-link-box wrap">
        <div class="friend-link-title"></div>
        <div class="links-box">
            <a v-for="(item,index) in linkdata" :key="index" class="item-link" :href="item.href" target="_blank"><img :src="item.img_url"></a>
        </div>
      </div>-->
      <div class="pop" v-show="popShow">
        <img src="../assets/fc.png" />
        <span class="btn-close" @click="closePop">X</span>
      </div>
      <div class="popss">
        <img src="../assets/a58d40ec7ab2a1e74b839929577c488.png" />
        <span class="btn-close" @click="closePop">安卓APP移动学习</span>
      </div>
      <div class="pop_two" v-show="popShows">
        <img src="../assets/wxts.jpg" @click="work_one()" />
        <span class="btn-close-two" @click="closePops">X</span>
      </div>
      <!-- <div class="pop_two" v-show="popShow">
        <img src="../assets/fkxzs.png" />
        <span class="btn-close" @click="closePop">X</span>
      </div> -->
    </div>
    <div class="foot-top">
      <span class="spn-one">友情链接 :</span>
      <a href="https://www.hnzjgl.gov.cn/" class="spn-five" target="_blank">河南省专业技术人员公共服务平台</a>
      <a href="http://www.jxjyedu.org.cn/" class="spn-four" target="_blank">河南省继续教育学会在线学习平台</a>
      <a href="https://www.hamc.edu.cn/" class="spn-four" target="_blank">河南省医学高等专科学校</a>
      <a href="http://www.hnwsjsw.gov.cn/" class="spn-four" target="_blank">河南省卫生健康委员会</a>
      <!--<a href="http://pxzx.hamc.edu.cn" class="spn-two" target="_blank">河南卫生人员培训中心</a>-->
    </div>
    <!-- <div class="laozi">
      <img src="/static/images/index/laozi.png" alt />
      <img src="../assets/laozi.png" alt="">
    </div>
    <div class="zuzi">
      <img src="/static/images/index/zhuzi.png" alt />
      <img src="../assets/shu.png" alt="">
    </div> -->
  </div>
</template>

<script>
  import $jquery from "jquery";
  import qs from "qs";
  import {
    Message
  } from "element-ui";
  import "swiper/dist/css/swiper.css";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  //import indexnews from "@/components/indexnews.vue";
  import indexlaws from "@/components/indexlaws.vue";
  import indexworks from "@/components/indexworks.vue";
  import indexhelps from "@/components/indexhelps.vue";
  import courses from "./courses";
  export default {
    name: "index",
    components: {
      indexlaws,
      indexworks,
      indexhelps,
      swiper,
      swiperSlide,
      courses,
    },
    data() {
      return {
        tanbol:false,
        idcard: '',
        UserPsd: '',
        newsjson: {
          title: "新闻咨讯",
          englishTitle: "NEWS INFORMATION",
          path: "/news",
          state: 0,
          list: ""
        },
        lawsjson: {
          title: "政策法规",
          englishTitle: "POLICIES REGULATIONS",
          path: "/laws",
          state: 0,
          list: ""
        },
        worksjson: {
          title: "工作动态",
          englishTitle: "WORK DYNAMICS",
          path: "/works",
          state: 0,
          list: ""
        },
        helpsjson: {
          title: "帮助中心",
          englishTitle: "HELP CENTER",
          path: "/helps",
          state: 0,
          list: ""
        },
        swiperOption: {
          loop: true,
          //autoplay: true,
          /* pagination: {
            el: ".swiper-pagination",
            clickable: true
          } */
        },
        idcard: "",
        UserPsd: "",
        picLyanzhengma: "",
        checkCode: "",
        //首页弹窗状态值  true 开启  false 关闭
        popShow: "true",
        popShows: "true",
        //课程列表
        courseslist: "",
        //轮播图
        swiperdata: "",
        //友情链接
        linkdata: "",
        //课程年份
        kecheng_year: "",
        //课程类型
        kecheng_type: "",
        //课程分类
        kecheng_category: "",
        //课程年份参数
        yearid: "",
        //课程类型参数
        typeid: "",
        //课程分类参数
        categoryid: "",
        //yeartabState
        yeartabState: "",
        //yeartabState
        typetabState: "",
        //yeartabState
        categorytabState: "",
        //登陆状态
        type: true,
        //根据性别显示图片
        sex: localStorage.getItem("sex"),
        //name
        name: localStorage.getItem("name"),
        token: localStorage.getItem("token"),
        //新闻和政策法规切换状态
        newslawsState: 0,
        //请求接口域名
        
      };
    },

    created() {
      this.createCode();
      this.type = false;
      localStorage.clear()
    },
    // watch: {
    //   token: {
    //     handler: function(val) {
    //       if (val) {
    //       } else {
    //         this.removeInfo();
    //       }
    //     }
    //   },
    //   deep: true
    // },
    mounted() {
      this.$axios.post('/index/is_open').then(res=>{
        if(res.data.data){
          this.tanbol = true
        }
      })

      let that = this;
      //轮播图
      this.$axios({
        method: "get",
        url:  "/lunbotu/get_lunbotu_list"
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("轮播图");
          //console.log(response.data);
          that.swiperdata = response.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //友情链接
      this.$axios({
        method: "get",
        url:  "/link/get_list"
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("友情链接");
          //console.log(response.data);
          that.linkdata = response.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //请求通知公告news
      let datanews = {
        type_id: "1",
        page: "1",
        num: "6"
      };
      this.$axios({
        method: "post",
        url:  "/news/get_news_list",
        data: qs.stringify(datanews)
      }).then(function(response) {
        if (response.data.status == "ok") {
          that.newsjson.state = 1;
          that.newsjson.list = response.data.data.data;
          //console.log(response.data.data.data);
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //请求政策法规laws
      let datalaws = {
        type_id: "2",
        num: "8"
      };
      this.$axios({
        method: "post",
        url:  "/news/get_news_list",
        data: qs.stringify(datalaws)
      }).then(function(response) {
        if (response.data.status == "ok") {
          that.lawsjson.state = 1;
          //console.log('政策法规');
          that.lawsjson.list = response.data.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
        }
      });
      //请求工作动态works
      let dataworks = {
        type_id: "3",
        num: "8"
      };
      this.$axios({
        method: "post",
        url:  "/news/get_news_list",
        data: qs.stringify(dataworks)
      }).then(function(response) {
        if (response.data.status == "ok") {
          that.worksjson.state = 1;
          that.worksjson.list = response.data.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //请求帮助中心helps
      let datahelps = {
        type_id: "4",
        num: "4"
      };
      this.$axios({
        method: "post",
        url:  "/news/get_news_list",
        data: qs.stringify(datahelps)
      }).then(function(response) {
        if (response.data.status == "ok") {
          that.helpsjson.state = 1;
          // //console.log("helps");
          that.helpsjson.list = response.data.data.data;
          // //console.log(response.data.data.data);
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          that.removeInfo();
        }
      });
      //获取课程年份
      this.$axios({
        method: "get",
        url:  "/kecheng/get_kecheng_year"
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("课程年份");
          //console.log(response.data.data);
          that.kecheng_year = response.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //获取课程类型
      this.$axios({
        method: "get",
        url:  "/kecheng/get_kecheng_type"
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("课程类型");
          //console.log(response.data.data);
          that.kecheng_type = response.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //获取课程分类
      this.$axios({
        method: "get",
        url:  "/kecheng/get_kecheng_category"
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("课程分类");
          //console.log(response.data.data);
          that.kecheng_category = response.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
      //获取课程列表
      let datacourse = {
        year: "2019",
        type_id: "",
        category_id: ""
      };
      this.$axios({
        method: "post",
        url:  "/kecheng/get_kecheng_list",
        data: qs.stringify(datacourse)
      }).then(function(response) {
        if (response.data.status == "ok") {
          //console.log("课程列表");
          //console.log(response.data.data.data);
          that.courseslist = response.data.data.data;
        } else if (response.data.status == "error") {
          that.$message.error({
            message: response.data.errormsg,
            duration: 1600
          });
        } else if (response.data.status == "relogin") {
          //that.removeInfo();
        }
      });
    },
    methods: {
      tanck(){
        this.tanbol = false
      },
      //工作动态跳转
      work_one() {
        this.$router.push({
          path: "/works"
        })
      },
      //证书查询跳转
      index_i() {
        this.$message.error({
          message: "请登录后查询",
          duration: 1600
        });
      },
      Login() {
        let that = this;
        if (this.idcard == '') {
          this.$message.error({
            message: "身份证号不能为空",
            duration: 1600
          });
        } else if (!this.idcard.match(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)) {
          this.$message.error({
            message: "请输入正确的身份证号",
            duration: 1600
          });
        } else if (this.UserPsd == '') {
          this.$message.error({
            message: "密码不能为空",
            duration: 1600
          });
          //console.log('123+12323213213')
        } else {

          let userinfo = {
            id_card: this.idcard,
            password: this.UserPsd
          };
          this.$axios.post( '/user/login', qs.stringify(userinfo)).then(response => {
            if (response.data.status == 'ok') {
              localStorage.setItem("uid", response.data.data.uid);
              localStorage.setItem("token", response.data.data.token);
              localStorage.setItem("sex", response.data.data.sex);
              localStorage.setItem("name", response.data.data.name);
              localStorage.setItem("mobile", response.data.data.mobile);
              localStorage.setItem("id_card", response.data.data.id_card);
              localStorage.setItem("login1", "1");
              that.sex = response.data.data.sex;
              this.name = response.data.data.name;
              that.$message.success({
                message: "登陆成功，即将前往个人中心页",
                duration: 1600
              });
              setTimeout(() => {
                that.$router.push({
                  path: '/my'
                });
              }, 1600);
            } else if (response.data.status == 'error') {
              this.$message.error({
                message: response.data.errormsg,
                duration: 1600
              });
            } else if (response.data.status == 'relogin') {
              localStorage.removeItem("login1");
              that.removeInfo();
              that.login1 = 0;
            }
          })

        }
      },
      // 图片验证码
      index_m() {
        this.$router.push({
          path: "/findpw"
        });
      },
      index_z() {
        this.$router.push({
          path: "/register"
        });
      },
      index_l() {
        this.$router.push({
          path: "/laws"
        });
      },
      index_g() {
        this.$router.push({
          path: "/news"
        });
      },
      index_w() {
        this.$router.push({
          path: "/works"
        });
      },
      index_x() {
        this.$router.push({
          path: "/helps"
        });
      },
      index_c() {
        this.$router.push({
          path: "/courses"
        });
      },
      createCode() {
        let code = "";
        var codeLength = 4; //验证码的长度
        var random = new Array(
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z"
        ); //随机数
        for (var i = 0; i < codeLength; i++) {
          //循环操作
          var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
          code += random[index]; //根据索引取得随机数加到code上
        }
        this.checkCode = code; //把code值赋给验证码
      },
      // 失焦验证图和密码
      checkLpicma() {
        this.picLyanzhengma.toUpperCase(); //取得输入的验证码并转化为大写
        if (this.picLyanzhengma == "") {
          this.$message.error({
            message: "请输入验证码",
            duration: 1600
          });
        } else if (this.picLyanzhengma.toUpperCase() != this.checkCode) {
          //若输入的验证码与产生的验证码不一致时
          this.$message.error({
            message: "验证码不正确",
            duration: 1600
          });
          this.createCode(); //刷新验证码
          this.picLyanzhengma = "";
        } else {
          //输入正确时
          return true;
        }
      },

      // 用户登录
      // Login() {
      //   let that = this;
      //   if (this.idcard == "") {
      //     this.$message.error({ message: "身份证号不能为空", duration: 1600 });
      //   } else if (
      //     !this.idcard.match(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)
      //   ) {
      //     this.$message.error({
      //       message: "请输入正确的身份证号",
      //       duration: 1600
      //     });
      //   } else if (this.UserPsd == "") {
      //     this.$message.error({ message: "密码不能为空", duration: 1600 });
      //   } else if (this.checkLpicma() == true) {
      //     let userinfo = { id_card: this.idcard, password: this.UserPsd };
      //     this.$axios
      //       .post(
      //         "http://jixujiaoyu_api.songlongfei.club/user/login",
      //         qs.stringify(userinfo)
      //       )
      //       .then(response => {
      //         //console.log("登陆成功返回信息");
      //         //console.log(response.data);
      //         if (response.data.status == "ok") {
      //           //console.log("111111");
      //           localStorage.setItem("uid", response.data.data.uid);
      //           localStorage.setItem("token", response.data.data.token);
      //           localStorage.setItem("sex", response.data.data.sex);
      //           localStorage.setItem("name", response.data.data.name);
      //           localStorage.setItem("mobile", response.data.data.mobile);
      //           localStorage.setItem("id_card", response.data.data.id_card);
      //           localStorage.setItem("login1", "1");
      //           that.login1 = 1;
      //           that.sex = response.data.data.sex;
      //           that.name = response.data.data.name;
      //           that.$router.push({ path: "my" });
      //         } else if (response.data.status == "error") {
      //           this.createCode(); //刷新验证码
      //           that.$message.error({
      //             message: response.data.errormsg,
      //             duration: 1600
      //           });
      //         } else if (response.data.status == "relogin") {
      //           that.removeInfo();
      //         }
      //       });
      //   }
      // },
      //跳往课程页
      tocourse(id) {
        this.$router.push({
          path: "courses",
          query: {
            typeid: id
          }
        });
      },
      //清除localstorge存储
      removeInfo() {
        let that = this;
        this.$message.error({
          message: "重新登录",
          duration: 1600
        });
        localStorage.removeItem("uid");
        localStorage.removeItem("token");
        localStorage.removeItem("sex");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("id_card");
        localStorage.setItem("types", "rate");
        setTimeout(() => {
          that.$router.push({
            path: "/login"
          });
        }, 1600);
      },
      //用户退出
      logout() {
        let that = this;
        let userinfo = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token")
        };
        this.$axios({
          method: "post",
          url:  "/user/logout",
          data: qs.stringify(userinfo)
        }).then(function(response) {
          if (response.data.status == "ok") {
            that.$message.success({
              message: "退出成功",
              duration: 1600
            });
            localStorage.removeItem("login1");
            that.removeInfo();
            that.type = true;
          } else if (response.data.status == "error") {
            that.login1 = 0;
            that.removeInfo();
            that.$message.error({
              message: response.data.errormsg,
              duration: 1600
            });
          } else if (response.data.status == "relogin") {
            that.login1 = 0;
            localStorage.removeItem("login1");
            that.removeInfo();
          }
        });
        localStorage.setItem("login1", "0");
        this.login1 = 0;
      },

      closePop() {
        this.popShow = false;
      },
      closePops() {
        this.popShows = false;
      },
      courseYear(id) {
        if (id) {
          this.yeartabState = id;
          this.yearid = id;
          this.getCourseList(this.yearid, this.typeid, this.categoryid);
        } else {
          this.yeartabState = "";
        }
      },
      courseType(id) {
        if (id) {
          this.typetabState = id;
          this.typeid = id;
          this.getCourseList(this.yearid, this.typeid, this.categoryid);
        } else {
          this.typetabState = "";
        }
      },
      courseCategory(id) {
        if (id) {
          this.categorytabState = id;
          this.categoryid = id;
          this.getCourseList(this.yearid, this.typeid, this.categoryid);
        } else {
          this.categorytabState = "";
        }
      },

      //点击标签选项后获取课程列表
      getCourseList(yearid, typeid, categoryid) {
        let that = this;
        let datacourse = {
          year: yearid,
          type_id: typeid,
          category_id: categoryid,
          page: "1",
          num: "10"
        };
        this.$axios({
          method: "post",
          url:  "/kecheng/get_kecheng_list",
          data: qs.stringify(datacourse)
        }).then(function(response) {
          if (response.data.status == "ok") {
            //console.log("课程列表");
            //console.log(response.data.data.data);
            that.courseslist = response.data.data.data;
          } else if (response.data.status == "error") {
            that.$message.error({
              message: response.data.errormsg,
              duration: 1600
            });
          } else if (response.data.status == "relogin") {
            that.removeInfo();
          }
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  // .zkindex {
  //   position: relative;
  // }
  .index {
    width: 1200px;
    margin: 20px auto 0;
    font-size: 0;
    position: relative;

    .swiper-news-login {
      width: 872px;
      height: 394px;
      box-sizing: border-box;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      background-color: #fff;

      .myswiper {
        width: 851px;
        height: 394px;
        margin: 0;

        .slider {
          width: 851px;
          height: 362px;

          img {
            width: 851px;
            height: 362px;
          }

          .slide-title {
            width: 851px;
            height: 40px;
            position: absolute;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            font-size: 14px;
            line-height: 40px;
            color: #fff;
            text-align: left;
            padding-left: 10px;
          }
        }

        .swiper-pagination-bullets {
          left: 670px;
          width: 140px;
          bottom: 45px;

          .swiper-pagination-bullet {
            width: 12px !important;
            height: 12px !important;
            background-color: #fff;
            opacity: 1;
            border-radius: 0 !important;
          }

          .swiper-pagination-bullet-active {
            background-color: red;
          }
        }
      }

      .news-laws {
        width: 315px;
        height: 394px;
        position: absolute;
        right: 0;
        top: 0;
        background: #ad0008;

        .news-title-box {
          width: 100%;
          margin-bottom: 30px;
          height: 48px;
          background: #ad0008;
          display: flex;

          a {
            font-size: 14px;
            color: #ad0008;
            margin-top: 10px;
            display: block;
            margin-top: 20px;

            button {
              cursor: pointer;
              width: 254px;
              height: 50px;
              line-height: 50px;
              padding: 0;
              border-radius: 5px;
              color: #fff;
              background: #AD0008;
              font-size: 16px;
              border: 1px #fff solid;
            }
          }

          div {
            width: 315px;
            height: 394px;

            div {
              height: 363px;
              width: 291px;
              border: 1px #dbdbdb solid;
              margin: 15px 11px;
              text-align: center;

              h3 {
                color: #000;
                font-size: 18px;
                margin-top: 18px;
              }

              p {
                font-size: 10px;
                color: #868686;
              }

              div {
                width: 257px;
                height: 12px;
                font-size: 12px;
                color: #868686;
                border: none;
                margin: 13px auto 23px;

                span:nth-child(2) {
                  float: left;
                  cursor: pointer;
                }

                span:nth-child(1) {
                  float: right;
                  cursor: pointer;
                  z-index: 100000000;
                }
              }

              p:nth-child(n+2) {
                padding-top: 14px;
              }

              input {
                height: 46px;
                width: 210px;
                border: 1px #c1c1c1 solid;
                border-radius: 5px;
                padding-left: 10px;
                background: #fff;
              }

              .button {
                padding: 15px 95px;
                border-radius: 5px;
                color: #ad0008;
                background: #fff;
                font-size: 16px;
                border: 1px #fff solid;
                cursor: pointer;
              }
            }
          }

          .cur {
            background-color: #AD0008;
            color: #fff;
          }

          .cur:before {
            content: "";
            width: 18px;
            height: 18px;
            background-color: #AD0008;
            position: absolute;
            left: 50%;
            bottom: -9px;
            transform: rotate(45deg);
            margin-left: -9px;
          }
        }

        .news-box {
          .news-content-box {
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

            &:hover {
              cursor: pointer;
            }

            .item {
              position: relative;
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;
              box-sizing: border-box;
              padding: 0 5px 0 12px;
              align-items: center;

              .item-title {
                width: 270px;
                font-size: 16px;
                color: #3d3d3d;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .item-time {
                font-size: 12px;
                color: #3d3d3d;
              }
            }

            .item:before {
              content: "";
              width: 6px;
              height: 6px;
              border-radius: 6px;
              background-color: #952418;
              position: absolute;
              left: 0px;
              top: 50%;
              display: block;
              margin-top: -3px;
            }

            .item:hover {
              div {
                color: #952418;
              }

              &:before {
                background-color: #952418;
              }
            }
          }
        }
      }

      .login-box {
        width: 292px;
        border: 1px solid #d7d7d7;

        .login-title-box {
          width: 100%;
          height: 55px;

          .login-title {
            width: 126px;
            height: 34px;
            background-image: url(/static/images/index/login-title.png);
            margin-top: 25px;
            margin-left: 18px;
          }
        }

        .info-box {
          width: 252px;
          margin: 0 auto;

          .btns-box {
            width: 100%;
            height: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
          }

          .find-pw {
            font-size: 12px;
            color: #878787;

            &:hover {
              color: #c60404;
            }
          }

          .btn-regin {
            font-size: 12px;
            color: #878787;

            &:hover {
              color: #c60404;
            }
          }
        }
      }
    }

    .procedure-box {
      display: block;
      width: 1200px;
      height: 67px;
      background-image: url(/static/images/index/procedure.png);
      margin: 30px auto;
      position: relative;

      a {
        position: absolute;
        width: 135px;
        height: 50px;
        display: block;
      }

      .xyzc {
        left: 10px;
        top: 10px;
      }

      .xkjf {
        left: 220px;
        top: 10px;
      }

      .zxxx {
        left: 425px;
        top: 10px;
      }

      .zxks {
        left: 630px;
        top: 10px;
      }

      .zscx {
        left: 1050px;
        top: 10px;
      }
    }

    .index-news {
      width: 1200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }

    .continue-education {
      width: 1200px;

      .continue-education {
        width: 100%;
        overflow: hidden;
      }

      .continue-edu-title {
        width: 394px;
        height: 42px;
        background-image: url(/static/images/index/continue-edu.png);
        margin: 40px auto;
      }

      .year-choose {
        display: flex;
        align-items: flex-start;
        height: 36px;

        .year-title {
          font-size: 16px;
          color: #3d3d3d;
          padding-bottom: 5px;
        }

        .year {
          display: flex;
          list-style: none;

          li {
            font-size: 16px;
            color: #3d3d3d;
            margin: 0 10px;
            padding-bottom: 5px;
            cursor: pointer;

            &:hover {
              border-bottom: 2px solid #eb2d2d;
            }
          }

          .on {
            border-bottom: 2px solid #eb2d2d;
          }
        }
      }

      .course-choose {
        display: flex;
        align-items: flex-start;
        height: 36px;

        .course-title {
          font-size: 16px;
          color: #3d3d3d;
          padding-bottom: 5px;
        }

        .course {
          display: flex;
          list-style: none;

          li {
            font-size: 16px;
            color: #3d3d3d;
            margin: 0 10px;
            padding-bottom: 5px;
            cursor: pointer;

            &:hover {
              border-bottom: 2px solid #eb2d2d;
            }
          }

          .on {
            border-bottom: 2px solid #eb2d2d;
          }
        }
      }

      .kinds-choose {
        display: flex;
        align-items: flex-start;
        height: 36px;

        .kinds-title {
          font-size: 16px;
          color: #3d3d3d;
          padding-bottom: 5px;
        }

        .kinds {
          display: flex;
          list-style: none;

          li {
            font-size: 16px;
            color: #3d3d3d;
            margin: 0 10px;
            padding-bottom: 5px;
            cursor: pointer;

            &:hover {
              border-bottom: 2px solid #eb2d2d;
            }
          }

          .on {
            border-bottom: 2px solid #eb2d2d;
          }
        }
      }
    }

    .course-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .course-item {
        width: 225px;
        height: 225px;
        margin-top: 20px;
        margin-left: 15px;
        display: block;

        &:hover {
          box-shadow: 0 0 10px #c1c1c1;
          cursor: pointer;
        }

        &:nth-child(5n + 1) {
          margin-left: 0;
        }

        .item-img {
          width: 225px;
          height: 126px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item-name {
          font-size: 14px;
          color: #313131;
          letter-spacing: 2px;
          padding: 0 8px;
          line-height: 20px;
          margin-top: 8px;
        }

        .item-other {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          padding: 0 8px;

          .item-time {
            color: #fb0808;
            font-size: 14px;
          }

          .item-teacher {
            color: #313131;
            font-size: 14px;
          }
        }
      }
    }

    // .friend-link-box{width: 1200px; margin: 0 auto;
    //   .friend-link-title{width: 100%;height: 34px;background-image: url(/static/images/index/friend-link.png);margin: 40px auto }
    //   .links-box{width: 100%;display: flex;flex-wrap:wrap;justify-content: space-between;
    //     .item-link{transform: scale(1);transition: all 1s;
    //       &:hover{transform: scale(1.1);transition: all 1s;}
    //     }
    //   }
    // }
  }

  .foot-top {
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    box-sizing: border-box;
    border-bottom: 1px solid #d2d2d2;
    background-color: #e3e3e3;
    margin-top: 30px;
  }

  .foot-top a {
    display: inline-block;
    color: #6b6b6b;
    font-size: 16px;
  }

  .foot-top .spn-one {
    color: #4c4c4c;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 18px;
  }

  .foot-top a.spn-two {
    padding: 0 15px;
    box-sizing: border-box;
    /* border-right: 1px solid #cccccc; */
  }

  .foot-top a.spn-three {
    padding: 0 30px;
    box-sizing: border-box;
    /* border-right: 1px solid #cccccc; */
  }

  .foot-top a.spn-four {
    padding: 0 25px;
    box-sizing: border-box;
    /* border-right: 1px solid #cccccc; */
  }

  .foot-top a.spn-five {
    padding: 0 30px;
    box-sizing: border-box;
  }

  .register_content_input {
    width: 252px;
    height: 48px;
    box-sizing: border-box;
    padding-left: 15px;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    margin: 0 auto;
    font-size: 14px;
  }

  .input-pw {
    margin-top: 12px;
  }

  .yanzhengma_input {
    width: 130px;
    height: 40px;
    font-size: 14px;
    box-sizing: border-box;
    padding-left: 15px;
    border-radius: 5px;
    border: 1px solid #c1c1c1;
    display: inline-block;
    vertical-align: middle;
    margin-top: 12px;
  }

  .verification1 {
    width: 100px;
    height: 40px;
    font-size: 18px;
    letter-spacing: 3px;
    color: #c60404;
    background: #f2f2f5;
    border-radius: 5px;
    border: 1px solid #c1c1c1;
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-top: 12px;
    cursor: pointer;
  }

  .user_login {
    display: block;
    width: 252px;
    height: 48px;
    font-size: 18px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    background-color: #c60404;
    border-radius: 5px;
    margin-top: 12px;
    cursor: pointer;
  }

  .pop {
    width: 145px;
    position: fixed;
    right: 0;
    top: 20%;
    z-index: 10;
  }

  .pop_two {
    max-width: 300px;
    position: fixed;
    left: 0;
    top: 40%;
    z-index: 100;
    /* img{
      height: 100%;
      width: 100%;
    } */
  }

  .pop_two .btn-close-two {
    width: 22px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    margin: 0 auto;
    cursor: pointer;
    text-align: center;
    color: #c1c1c1;
    border-radius: 22px;
    border: 1px solid #c1c1c1;
    display: block;
  }

  .pop .btn-close {
    width: 22px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    margin: 0 auto;
    cursor: pointer;
    text-align: center;
    color: #c1c1c1;
    border-radius: 22px;
    border: 1px solid #c1c1c1;
    display: block;
  }

  .login-index-success {
    width: 292px;
    height: 336px;
    position: relative;
    float: left;
    background-color: #fff;
    padding-top: 30px;
    border: 1px solid #c6c6c6;
    box-sizing: border-box;
  }

  .login-index-success .user-image {
    width: 90px;
    height: 90px;
    border-radius: 90px;
    border: 1px solid #1379c4;
    margin: 0 auto;
    background-size: 100% 100%;
    display: block;
  }

  .login-index-success .user-name {
    width: 240px;
    height: 20px;
    font-size: 16px;
    margin: 10px auto;
    text-align: center;
  }

  .login-index-success .title {
    width: 240px;
    height: 30px;
    font-size: 14px;
    margin: 10px auto;
    text-align: center;
  }

  .login-index-success .btn-personal {
    width: 240px;
    height: 45px;
    background-color: #c60406;
    margin: 15px auto 0;
    cursor: pointer;
  }

  .login-index-success .btn-login {
    width: 240px;
    height: 45px;
    background-color: #c60406;
    margin: 15px auto 0;
    cursor: pointer;
  }

  .login-index-success .btn-personal a {
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
    line-height: 45px;
    display: block;
    font-size: 12px;
  }

  .login-index-success .btn-login span {
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
    line-height: 45px;
    display: block;
    font-size: 12px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clearfix {
    zoom: 1;
  }

  .box {
    margin-top: 20px;
    height: 387px;
    width: 872px;

    div {
      height: 387px;
      width: 430px;
      background: #fff;
      float: left;

      div {
        width: 408px;
        height: 45px;
        margin-left: 11px;
        line-height: 45px;
        border-bottom: 2px #dedede solid;
        margin-bottom: 20px;

        span:nth-child(1) {
          font-size: 16px;
          border-bottom: #ad0008 2px solid;
          padding-bottom: 10px;
        }

        span:nth-child(2) {
          font-size: 13px;
          color: #868686;
          float: right;
        }

      }
    }

    .float_l {
      float: right;
    }

    .index_li {
      list-style-type: none;
      font-size: 16px;
      height: 36px;
      width: 408px;
      color: #000;
      line-height: 36px;

      span:nth-child(1),
      span:nth-child(2) {
        float: left;
      }

      span:nth-child(2) {
        display: block;
        width: 284px;
        overflow: hidden;
        height: 36px;
      }

      span:nth-child(3) {
        float: right;
        font-size: 11px;
        color: #a0a0a0;
        margin-right: 11px;
      }

      span:nth-child(1) {
        display: block;
        height: 4px;
        width: 4px;
        border-radius: 2px;
        background: #942416;
        margin: 15px 16px 0 16px;
      }
    }
  }

  .box .left {
    padding: 27px;
    box-sizing: border-box;
    background-color: #fff;
    width: 67%;
  }

  .box h3 {
    width: 100%;
    letter-spacing: 1px;
    border-bottom: 1px solid #dedede;
  }

  .box h3 .spn {
    font-size: 20px;
    display: inline-block;
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #a81b15;
  }

  .box .left ul li {
    list-style: none;
    float: left;
    width: 178px;
    height: 64px;
    border: 2px solid #f0f0f0;
    text-align: center;
    line-height: 60px;
    margin-top: 10px;
    margin-right: 12px;
    cursor: pointer;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &:nth-child(9) {
      cursor: not-allowed;
    }

    &:nth-child(10) {
      cursor: not-allowed;
    }

    &:nth-child(11) {
      cursor: not-allowed;
    }

    &:nth-child(12) {
      cursor: not-allowed;
    }
  }

  .box .left ul li:nth-child(4n) {
    margin-right: 0;
  }

  .box .left ul li span {
    display: inline-block;
    font-size: 18px;
  }

  .box .left ul li span:nth-child(1) {
    width: 27px;
    margin-right: 10px;
  }

  .box .left ul li span img {
    width: 100%;
    vertical-align: -5px;
  }

  .box .right {
    width: 31.6%;
    height: 321px;
    box-sizing: border-box;
  }

  .box .right div {
    height: 150px;
  }

  .box .right div img {
    width: 100%;
    height: 150px;
  }

  .box .right div.bottom {
    margin-top: 20px;
  }

  .laozi {
    width: 179px;
    position: absolute;
    left: 0;
    bottom: 120px;
    overflow: hidden;
  }

  .laozi img {
    width: 100%;
    height: 100%;
  }

  .zuzi {
    width: 252px;
    height: 302px;
    position: absolute;
    right: 0;
    bottom: 140px;
  }

  .index_sear {
    height: 386px;
    width: 314px;
    position: absolute;
    right: 0;
    top: 414px;

    .search {
      height: 85px;
      width: 314px;
      background: #AD0008;

      input {
        height: 67px;
        width: 197px;
        background: #AD0008;
        border: 1px #fff solid;
        color: #fff;
        padding-left: 24px;
        font-size: 17px;
        margin: 8px 0 0 10px;
        cursor: pointer;
      }

      img {
        border: 1px #fff solid;
        padding: 16px 19px;
        border-left: none;
        margin-top: 7px;
        cursor: pointer;
      }

      input::-webkit-input-placeholder {
        color: #fff;
      }
    }

    .index_work {
      width: 314px;
      height: 289px;
      background: #fff;
      margin-top: 14px;

      div {
        width: 289px;
        height: 45px;
        line-height: 45px;
        border-bottom: 2px #dddfdc solid;
        margin: 0 auto;

        span:nth-child(1) {
          font-size: 16px;
          border-bottom: #ad0008 2px solid;
          padding-bottom: 10px;
        }

        span:nth-child(2) {
          color: #868686;
          font-size: 13px;
          float: right;
          cursor: pointer;

        }
      }

      .index_w {
        height: 36px;
        width: 288px;
        line-height: 36px;
        font-size: 14px;
        color: #000;
        display: inline-block;
        margin-left: 15px;

        span:nth-child(1) {
          display: inline-block;
          height: 4px;
          width: 4px;
          background: #96231c;
          border-radius: 2px;
          float: left;
          margin: 17px 10px 15px 1px;
        }

        span:nth-child(2) {
          display: inline-block;
          height: 36px;
          width: 170px;
          border-radius: 2px;
          float: left;
          white-space: nowrap;
          /*规定段落中的文本不进行换行*/
          overflow: hidden;
          /*内容会被修剪，并且其余内容是不可见的。*/
          text-overflow: ellipsis;
        }

        span:nth-child(3) {
          font-size: 11px;
          float: right;
          color: #a0a0a0;
        }
      }
    }
  }

  .index_ban {
    height: 191px;
    width: 1200px;
    margin-top: 14px;

    div:nth-child(1) {
      height: 191px;
      width: 872px;
      background: #fff;
      float: left;

      p {
        height: 40px;
        width: 851px;
        line-height: 40px;
        font-size: 16px;
        border-bottom: 2px #dfdde0 solid;
        margin: 0 auto;

        span {
          border-bottom: 2px #AD0008 solid;
          padding-bottom: 7px;
        }
      }

      img:nth-child(1),
      img:nth-child(2) {
        margin: 12px 16px 14px 11px;
      }
    }

    div:nth-child(2) {
      height: 191px;
      width: 314px;
      float: right;
      background: #fff;

      p {
        width: 290px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border-bottom: 2px #dfdde0 solid;
        margin: 0 auto;

        span:nth-child(1) {
          border-bottom: #AD0008 2px solid;
          padding-bottom: 8px;
        }

        span:nth-child(2) {
          font-size: 13px;
          color: #868686;
          float: right;
          cursor: pointer;
        }
      }
    }

    .index_h {
      height: 36px;
      width: 288px;
      line-height: 36px;
      font-size: 14px;
      color: #000;
      display: inline-block;
      margin-left: 15px;

      span:nth-child(1) {
        display: inline-block;
        height: 4px;
        width: 4px;
        background: #96231c;
        border-radius: 2px;
        float: left;
        margin: 17px 10px 15px 1px;
      }

      span:nth-child(2) {
        display: inline-block;
        height: 36px;
        width: 170px;
        border-radius: 2px;
        float: left;
        white-space: nowrap;
        /*规定段落中的文本不进行换行*/
        overflow: hidden;
        /*内容会被修剪，并且其余内容是不可见的。*/
        text-overflow: ellipsis;
      }

      span:nth-child(3) {
        font-size: 11px;
        float: right;
        color: #a0a0a0;
      }
    }
  }

  .index_cour {
    width: 1200px;
    background: #fff;
    margin-top: 14px;

    p {
      height: 40px;
      width: 1173px;
      line-height: 40px;
      font-size: 16px;
      border-bottom: 2px #dfdde0 solid;
      margin: 0 auto;

      span:nth-child(1) {
        padding-bottom: 8px;
        border-bottom: #AD0008 2px solid;
      }

      span:nth-child(2) {
        font-size: 11px;
        float: right;
        color: #a0a0a0;
        cursor: pointer;
      }
    }

    div {
      width: 1173px;
      margin: 0 auto;
      margin-top: 15px;
    }
  }

  .index_y {
    height: 194px;
    width: 1200px;
    background: #fff;
    margin-top: 14px;

    p {
      height: 40px;
      width: 1173px;
      margin: 0 auto;
      font-size: 16px;
      border-bottom: 2px #dfdde0 solid;
      line-height: 40px;

      span {
        padding-bottom: 8px;
        border-bottom: 2px #AD0008 solid;
      }
    }

    .index_d {
      height: 106px;
      width: 1173px;
      margin: 0 auto;

      a {
        height: 106px;
        width: 272px;
        border: 1px #ccc solid;
        text-align: center;
        display: inline-block;
        margin: 22px 23px 0 0;
        line-height: 24px;
        color: #000;

        div:nth-child(1) {
          font-size: 20px;
          margin-top: 20px;
        }

        div:nth-child(2) {
          font-size: 20px;
          margin-top: 10px;
        }
      }

      a:hover {
        color: #fff;
      }
    }

    .index_for {
      height: 106px;
      width: 1173px;
      margin: 0 auto;

      a {
        display: block;
        height: 106px;
        width: 272px;
        border: 1px #ccc solid;
        float: left;
        text-align: center;
        color: #000;

        div {
          font-size: 20px;
        }
      }

      a:nth-child(1),
      a:nth-child(2) {
        line-height: 106px;
        margin: 22px 23px 0 0;
      }

      a:nth-child(3),
      a:nth-child(4) {
        margin: 22px 23px 0 0;

        div:nth-child(1) {
          font-size: 20px;
          margin-top: 20px;
        }

        div:nth-child(2) {
          font-size: 20px;
          margin-top: 10px;
        }
      }

      a:nth-child(4) {
        margin-right: 0;
      }
    }

    a:hover {
      color: #fff;
    }
  }

  .a_img:hover {
    background-image: url('../assets/xxlj.jpg');
    color: #fff;
  }
  .popss{
    position: fixed;
    height: 154px;
    width: 144px;
    right: 10px;
    top: 65%;
    background: #fff;
    text-align: center;
    img{
      height: 122px;
      width: 122px;
      padding: 10px 10px 10px 10px;
    }
    span{
      display: block;
      font-size: 10px;
      margin-top: -10px;
    }
  }
  .tankuang{
    background: #000;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 100000;
    opacity: 0.9;
    text-align: center;
    img{
      margin-top: 17%;
      height: 300px;
      width: 550px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue